module.exports = __webpack_public_path__ + "media/images/ohap_Folder_Close-a4a4920bb8b1ae6522704573cbc3a396.png";